import React from 'react';

import { Tabs as MantineTabs, TabsProps } from '@mantine/core';
import { generatePath, useNavigate, useParams } from 'react-router-dom';

const Tabs = ({
  items,
  pathPattern,
  ...tabsProps
}: Omit<TabsProps, 'children'> & {
  items: {
    label: string | JSX.Element;
    value: string;
    component: JSX.Element;
    tabProps?: any;
    disabled?: boolean;
  }[];
  pathPattern: string;
}): JSX.Element => {
  const navigate = useNavigate();
  const params = useParams<{ [key: string]: string; activeTab: string }>();

  const active: string = items.find(item => item.value === params.activeTab)?.value || items[0].value;

  const handleChange = (value: string): void => {
    const pathToRoute = generatePath(pathPattern, { ...params, activeTab: value });
    navigate(pathToRoute);
  };

  return (
    <MantineTabs keepMounted={false} value={active} onTabChange={handleChange} {...tabsProps}>
      <MantineTabs.List>
        {items.map(item => (
          <MantineTabs.Tab
            {...item.tabProps}
            key={item.value}
            value={item.value}
            active={item.value === params.activeTab}
            data-cy={`tab${item.label}`}
            disabled={!!item.disabled}
          >
            {item.label}
          </MantineTabs.Tab>
        ))}
      </MantineTabs.List>
      {items.map(item => (
        <MantineTabs.Panel key={item.value} value={item.value}>
          {item.component}
        </MantineTabs.Panel>
      ))}
    </MantineTabs>
  );
};

export default Tabs;
